import { Accordion, Button, Card, Heading, Page, Spacer, ErrorBoundary } from '@oliasoft-open-source/react-ui-library';

const SentryTestCardContent = () => {
  throw new Error('Testing exception inside React component render');
};

const TestComponentRenderException = () => {
  return (
    <Accordion
      heading={<Heading>React component render exception test (expand to trigger error)</Heading>}
      bordered
      managed
    >
      <ErrorBoundary>
        <SentryTestCardContent />
      </ErrorBoundary>
    </Accordion>
  );
};

const TestComponentEventHandlerException = () => {
  return (
    <Card heading={<Heading>React component event handler exception test</Heading>}>
      <Button
        label="Button click exception test"
        onClick={() => {
          throw new Error('Testing exception inside button click handler');
        }}
      />
    </Card>
  );
};

const TestSentry = () => {
  return (
    <Page left={0} scroll>
      <Heading top>Oliasoft Internal Sentry Testing Page</Heading>

      <TestComponentRenderException />

      <Spacer />

      <TestComponentEventHandlerException />
    </Page>
  );
};

export default TestSentry;
